/**
 * Messages REST API
 * ─────────────────
 * Thin axios wrapper. The socket connection handles real-time updates;
 * these calls are for initial load, pagination, and fallbacks.
 */

import api from './axios';

export const messagesApi = {
  // Sidebar list
  listConversations: () => api.get('/messages/conversations'),

  // Open or create a 1-1 (or group) chat
  //   payload: { participants: [userId], context?: { type, refId }, isGroup?, name? }
  findOrCreate: (payload) => api.post('/messages/conversations', payload),

  // Message history (paginated)
  //   params: { before?: ISO date, limit?: number }
  getMessages: (conversationId, params = {}) =>
    api.get(`/messages/conversations/${conversationId}/messages`, { params }),

  // REST fallback send (sockets are preferred)
  sendMessage: (conversationId, payload) =>
    api.post(`/messages/conversations/${conversationId}/messages`, payload),

  markRead: (conversationId) =>
    api.patch(`/messages/conversations/${conversationId}/read`),

  deleteMessage: (messageId) =>
    api.delete(`/messages/messages/${messageId}`),
};